import { useMemo } from 'react'
import type { SelectItemEvent, CurrencyCode } from '@faststore/sdk'
import type {
  BrowserProductQueryQuery,
  ProductSummary_ProductFragment,
} from '@generated/graphql'
import { useSession } from 'src/sdk/session'
import { sendAnalyticsEvent } from '@faststore/sdk'
import { sendErrorLog } from 'src/utils/log/sendErrorLog'
// import { getCookie } from 'src/utils/cookie'

export type ProductLinkOptions = {
  index: number | undefined
  product: ProductSummary_ProductFragment | BrowserProductQueryQuery['product']
}

export const useProductLink = ({ index, product }: ProductLinkOptions) => {
  const { slug } = product
  const idSKU = slug.split('-').pop()
  const slug2 = slug.replace(`-${idSKU}`, '')
  // const uuidToUse = getCookie('uuid')
  const {
    currency: { code },
  } = useSession()

  const selectOffer = product?.offers?.offers?.findIndex(
    (prev) =>
      product.offers.lowPrice === prev?.price || product.offers.lowPrice === 0
  )

  return useMemo(() => {
    const onClick = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      sendAnalyticsEvent<SelectItemEvent, any>({
        name: 'select_item',
        params: {
          items: [
            {
              item_id: product.isVariantOf?.productGroupID,
              item_name: product.isVariantOf?.name,
              item_brand: product.brand?.name,
              item_variant: product.sku,
              index,
              price: product.offers?.offers[selectOffer]?.price,
              discount:
                product.offers?.offers[selectOffer]?.listPrice -
                product.offers?.offers[selectOffer]?.price,
              currency: code as CurrencyCode,
              item_variant_name: product.name,
              product_reference_id: product.gtin,
            },
          ],
          // uuid: uuidToUse,
        },
      })
    }

    // eslint-disable-next-line vtex/prefer-early-return
    if (product?.offers?.offers?.[selectOffer]) {
      const URLError = window?.location?.href
      const errorInfo = { product }

      const errorData = {
        error: 'Offers not returned from response',
        errorInfo,
        URLError,
        files: 'useProductLink',
      }

      sendErrorLog(errorData)
    }

    return {
      to: `/${slug2}/p`,
      onClick,
      'data-testid': 'product-link',
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug, code, product, index, selectOffer])
}
